import { Button } from "antd";
import React from "react";

export default function IconButton({ icon, green, label, onClick, style }) {
  return (
    <div style={{ cursor: "pointer", ...style }} onClick={onClick}>
      <Button
        type={green ? "default" : "primary"}
        shape="circle"
        icon={icon}
        style={
          green
            ? {
                borderColor: "var(--color-secondary)",
                color: "var(--color-secondary)",
              }
            : {}
        }
      />
      <Button
        className="text-bold"
        type="link"
        style={
          green
            ? {
                color: "var(--color-secondary)",
              }
            : {}
        }
      >
        {label}
      </Button>
    </div>
  );
}
